import { Row, Card, Col, Form } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect, useState } from "react";
import 'react-phone-input-2/lib/style.css'
import { setGlobalErrorStatus, setGlobalSuccessStatus } from 'Components/StatusHandling';
import { useDispatch } from "react-redux"
import 'react-phone-input-2';

import DynamicFormPopup from "Components/Popup/DynamicFormPopup";


function StatusPopup ({show, handleClose,variant, title, message, buttons, showStatusPopup}) {
    //const navigate = useNavigate();
    const dispatch = useDispatch();
    
    

    var popupButtons = [
        {
            text: "OK",
            action: handleClose,
            variant: "comp-primary",
            size: "lg",
            className:'w-xs-100 w-md-fit-content',
            //disabled: feedbackCharCount < 1 || isFeedbackLoading==true ? true: false
        }
    ]

    // var stayPopupButtons = [
    //     {
    //         text: "Stay Here",
    //         //action: submitGeneralComment,
    //         variant: "comp-primary",
    //         size: "lg",
    //         //disabled: feedbackCharCount < 1 || isFeedbackLoading==true ? true: false
    //     },
    //     {
    //         text: "Discard Comments",
    //         //action: handleClose,
    //         variant: "comp-outline",
    //         size: "lg",
    //         //disabled: false
    //     }
    // ]
   
    return (
        <Row id="status-popup" >
            <DynamicFormPopup
                showPopup = {show}
                handleClose = {handleClose}
                buttons = {buttons!=null ? buttons : popupButtons}
                title = {title}
                variant={variant}
                id="status-popup"
                combo={true}
            >
                {
                    showStatusPopup!=null && showStatusPopup==true
                    ?   <>{message} Please contact the PSOPPC Help Desk at <a href="mailto:support@psoppc.org">support@psoppc.org</a> to report the issue.</>
                    :   message
                }
                
            </DynamicFormPopup>
        </Row>
    );
}

export default StatusPopup;
